import React from 'react';
import { t } from '../../../locales/i18n';
import { Button } from 'semantic-ui-react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function CancelButton(props: any) {
  return (
    <Button
      type="button"
      disabled={props.disabled}
      content={t('Cancel')}
      className="cancel-button"
      onClick={props.onCancel}
    />
  );
}
